import React from 'react';
import { connect } from 'react-redux';
import PageContent from 'src/component/PageContent';

export interface OwnProps {
}

export interface Props extends OwnProps {

}

const Dashboard = (props: Props) => (
  <PageContent title="Dashboard">
    content
  </PageContent>
);

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Dashboard);
